import { render } from "./PrescriptionOrdonnance.vue?vue&type=template&id=39f4014b&scoped=true"
import script from "./PrescriptionOrdonnance.vue?vue&type=script&lang=js"
export * from "./PrescriptionOrdonnance.vue?vue&type=script&lang=js"

import "./PrescriptionOrdonnance.vue?vue&type=style&index=0&id=39f4014b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f4014b"]])

export default __exports__